import axios from 'axios';

// Create axios instance
const client = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // 쿠키 전송 활성화
});

// Request interceptor to add auth token
client.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('adminToken');
    // Exclude public endpoints from Auth header
    if (token && !config.url?.match(/\/login|\/register|\/refresh/)) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
client.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    
    // If 401 or 402 (token expired) and not already retrying
    if (error.response && (error.response.status === 401 || error.response.status === 402) && !originalRequest._retry) {
      // Don't intercept 401 for login endpoints - let the caller handle it
      if (originalRequest.url?.match(/\/login|\/register/)) {
        return Promise.reject(error);
      }

      originalRequest._retry = true;
      // deviceId는 필요하다면 전송 (서버 로직에 따라 필수일 수도 있고 쿠키에서 유추할 수도 있음)
      // 현재 서버 로직은 쿠키가 있으면 쿠키 내부의 deviceId를 사용하거나, 
      // 쿠키 파싱 실패 시 body를 확인.
      // 안전하게 deviceId는 함께 보내는 것이 좋음 (컨텍스트 유지를 위해)
      const deviceId = localStorage.getItem('adminDeviceId');

      if (deviceId) {
        try {
          const baseUrl = process.env.REACT_APP_API_URL;
          // Refresh Token은 쿠키로 자동 전송됨 via withCredentials: true
          const response = await axios.post(`${baseUrl}/admin/refresh`, {
            // refreshToken: ... (removed)
            deviceId // Optional but helpful context
          }, { withCredentials: true });
          
          if (response.status === 200) {
            const { accessToken } = response.data;
            localStorage.setItem('adminToken', accessToken);
            // refreshToken은 쿠키로 갱신되므로 로컬 스토리지 저장 불필요
            
            client.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
            originalRequest.headers['Authorization'] = `Bearer ${accessToken}`;
            
            return client(originalRequest);
          }
        } catch (refreshError) {
          // Refresh failed
          console.error("Token refresh failed", refreshError);
        }
      }

      // Clear tokens and redirect to login if unauthorized or refresh failed
      localStorage.removeItem('adminToken');
      // localStorage.removeItem('adminRefreshToken'); // No longer used
      // localStorage.removeItem('adminDeviceId'); // Keep deviceId
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default client;
